import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=4331fc4c&scoped=true"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"
import style0 from "./MessagesView.vue?vue&type=style&index=0&id=4331fc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331fc4c",
  null
  
)

export default component.exports